import { apiRequest } from './client';
import type { PlaylistItem } from '@kioskforge/shared';

/**
 * X2.3 — playlists and schedules client (mirrors A7's `/api/v1/playlists` and the
 * screen schedule in the screen DTO). Playlists publish through the same
 * versioning/snapshot/rollback rules as deployments (X2.2) — no second mechanism.
 */

export type PlaylistDto = {
  id: string;
  name: string;
  status: 'draft' | 'published';
  version: number;
  items: PlaylistItem[];
};

export async function listPlaylists(): Promise<PlaylistDto[]> {
  const body = await apiRequest<{ playlists: PlaylistDto[] }>('/playlists');
  return body.playlists ?? [];
}

export async function getPlaylist(id: string): Promise<PlaylistDto> {
  const body = await apiRequest<{ playlist: PlaylistDto }>(`/playlists/${encodeURIComponent(id)}`);
  return body.playlist;
}

export async function createPlaylist(input: { name: string; items: PlaylistItem[] }): Promise<PlaylistDto> {
  const body = await apiRequest<{ playlist: PlaylistDto }>('/playlists', { method: 'POST', body: input });
  return body.playlist;
}

/** Freeze the items and bump the version (ETag changes). */
export async function publishPlaylist(id: string, items?: PlaylistItem[]): Promise<PlaylistDto> {
  const body = await apiRequest<{ playlist: PlaylistDto }>(`/playlists/${encodeURIComponent(id)}/publish`, {
    method: 'POST',
    body: items === undefined ? {} : { items }
  });
  return body.playlist;
}

export async function deletePlaylist(id: string): Promise<{ ok: boolean }> {
  return apiRequest(`/playlists/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
